export default __webpack_public_path__ + "static/media/1029.fc4655b2.png";